<style lang="scss">
.color-loader.spinner {
    &::after,
    &::before {
        background: #037a8e !important;
    }
    & div.hex-brick {
        background: #037a8e !important;
        &.h1,
        &.h2,
        &.h3 {
            background: #037a8e !important;
        }
    }
    &.rotate-square2 {
        top: 35%;
    }
    &.socket {
        top: 25%;
    }
    &.circle5 {
        top: 25%;
    }
}

.circle5 {
    top: 40% !important;
}
</style>
<!-- App Main Structure -->
<template>
    <div class="app-default-layout">
        <template v-if="loading">
            <!-- <socket size="400px" class="color-loader hex-brick"></socket> -->
            <socket size="400px" class="color-loader socket"></socket>
        </template>
        <template v-else>
            <!-- App Header -->
            <app-header></app-header>
            <!-- App Main Content -->
            <v-content>
                <!-- App Router -->
                <transition name="router-anim" :enter-active-class="`animated ${selectedRouterAnimation}`">
                    <router-view></router-view>
                </transition>

                <bc-snackbar :value="global_snackbar" ref="global_snackbar" :timeout="0" :text="$t('lang.loading')"></bc-snackbar>
            </v-content>
            <!-- User Tour -->
            <!-- <bc-tour :current_tour="current_tour"></bc-tour> -->
        </template>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Header from "Components/Header/Header.vue";
// import BcTour from "Components/Tour/BcTour";
import _ from "lodash";

export default {
    data() {
        return {
            loading: true,
        };
    },
    components: {
        appHeader: Header,
        // BcTour
    },
    computed: {
        ...mapGetters(["selectedRouterAnimation", "languages", "current_tour"]),
        ...mapState({
            global_snackbar: (state) => state.settings.global_snackbar,
        }),
    },
    watch: {
        "$bp.width": function (newVal, oldVal) {
            // update drawer on width change
            if (oldVal >= 1300 && newVal < 1300) {
                this.$store.commit("toggleMainMenu", false);
            } else if (oldVal < 1300 && newVal >= 1300) {
                this.$store.commit("toggleMainMenu", true);
            }
        },
    },
    created() {
        window.addEventListener("keydown", (e) => {
            this.watchEscape(e);
        }); //TODO: set this active while there is a dialog open to minimize use
    },
    destroyed() {
        window.removeEventListener("keydown", (e) => {
            this.watchEscape(e);
        });
    },
    methods: {
        // method to allow modals to be closed with escape
        watchEscape(e) {
            if (!e.repeat) {
                const key = e.key;
                if (key === "Escape") {
                    this.$root.$emit("escapePressed");
                }
            }
        },
    },
    mounted() {
        setTimeout(() => {
            this.loading = false;
            // on mount if user tours are enabled and user preference has tours on, show tour on login
            setTimeout(() => {
                if (this.current_tour) {
                    //AppConfig.enableUserTour
                    this.$tours["currentTour"].start();
                }
            }, 1000);
        }, 2000);

        // change language to users saved language
        if (this.current_user) {
            let language = this.languages[this.current_user.language];
            if (language) {
                this.$root.$i18n.locale = language.locale;
                this.$store.dispatch("changeLanguage", language);
            }

            // make change in local storage as well
            // let userItem = JSON.parse(localStorage.getItem('user'));
            // if(userItem){
            //     userItem.user.language = language.locale;
            //     localStorage.setItem('user', JSON.stringify(userItem));
            // }
        }
    },
};
</script>

<style scoped>
.app-default-layout {
    height: 100vh;
}
</style>
